export default __webpack_public_path__ + "static/11-c41d97785d744dbab552b1fb5dd990a7.jpg";